export default __webpack_public_path__ + "static/media/logo.d629b530.png";